import React, { Component } from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { PushButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import { OUTPUT_TTL } from '../../constants/Pac';

@inject('batchStore')
@observer
class Horn extends Component {
  render() {
    const { device, batchStore } = this.props;
    const active = batchStore.isOutputOn(device.switchPNo) ? 'active' : '';
    const btnClass = active ? 'active btn-batch-red' : 'btn-batch-green';

    return (
      <div id={`device-${device.id}`} className={`${active} device-gui device-gui--horn device-icon-${device.icon}`}>
        {device.description && (
          <div className="device-label device-icon">
            <div className="device-type" title={`#${device.id}`}>{device.description}</div>
          </div>
        )}
        <div className="device-icon body"/>
        <div className="device-icon wave"/>
        <div className="device-gui__row">
          <PushButton
            className={`btn-batch ${btnClass}`}
            port={device.switchPNo}
            onPush={() => {
              batchStore.setOutput(device.switchPNo, OUTPUT_TTL);
            }}
          >
            <i className="fa fa-power-off" />
          </PushButton>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Horn);
